const $body = $('body'),
    classPopup = 'popup',
    classPopupWindow = 'popup__content',
    classPopupTrigger = 'popup__trigger',
    classPopupVisible = 'popup--visible',
    classPopupPosFlipped = 'popup--flipped',
    classPopupWindowMoved = 'popup__content--moved';

// check if popups are positioned out of screen and adjust position
function fixPopupPosition() {
    $('.'+classPopupWindow).each( function() {
        let $window = $(this),
            $popup = $window.closest('.'+classPopup),
            xPos,
            min_xPos = 15,
            max_xPos = ( viewport().width-15 )-$window.outerWidth(),
            defaultMarginLeft = -145,
            xDifference;

        if ( $window.hasClass(classPopupWindowMoved) ) {
            $window.removeClass(classPopupWindowMoved).css({ 'marginLeft' : defaultMarginLeft });
        }

        xPos = $window.offset().left;

        if( xPos < min_xPos ) {
            xDifference = min_xPos - xPos;

            if( xDifference > 0 ) {
                $window.addClass(classPopupWindowMoved).css({ 'marginLeft' : (defaultMarginLeft+xDifference) });
            }
        } else if( xPos > max_xPos ) {
            xDifference = xPos - max_xPos;

            if( xDifference > 0 ) {
                $window.addClass(classPopupWindowMoved).css({ 'marginLeft' : (defaultMarginLeft-xDifference) });
            }
        }

        // check if there is enough room below to expand popup down, else open in up direction
        if ($popup.hasClass(classPopupPosFlipped)) {
            $popup.removeClass(classPopupPosFlipped);
        }

        let popupHeight = $window.outerHeight(),
            popupYStart = $window[0].getBoundingClientRect().top,
            popupWrapperYStart = $popup[0].getBoundingClientRect().top,
            popupOffset = 60;

        if (popupHeight + popupYStart > (viewport().height - popupOffset)) {
            // only flip if there is enough room above to expand
            if ((popupWrapperYStart - popupOffset) > popupHeight) {
                $popup.addClass(classPopupPosFlipped);
            }
        } else {
            // console.log('there is enough space below!');
        }
    });
}

// set positions on page-load
fixPopupPosition();
setTimeout(fixPopupPosition, 100);

$body.on( 'click', '.'+classPopupTrigger, function(e) {
    e.preventDefault();

    let $popup = $(this).closest('.'+classPopup);

    // close all other currently open popups
    $('.'+classPopup).not($popup).each( function() {
        if( $(this).hasClass(classPopupVisible) ) {
            $(this).removeClass(classPopupVisible);
        }
    });

    if( $popup.hasClass(classPopupVisible) ) {
        $popup.removeClass(classPopupVisible);
    } else {
        fixPopupPosition();
        $popup.addClass(classPopupVisible);
    }

    $(this).blur();
});

$(document).on('click', function(e) {
    // close popup when clicking outside window
    if ( ! $(e.target).closest('.'+classPopup).length > 0 ) {

        $('.'+classPopup).each( function() {
            if( $(this).hasClass(classPopupVisible) ) {
                $(this).removeClass(classPopupVisible);
            }
        });
    }
});


// if escape key is pressed, close all open popups
$(document).keyup(function (e) {
    if (e.keyCode == 27) {
        $('.'+classPopup).each( function() {
            if( $(this).hasClass(classPopupVisible) ) {
                $(this).removeClass(classPopupVisible);
            }
        });
    }
});